import React from 'react';
import styled from 'styled-components';
import { Box } from 'rebass/styled-components';
import { colors } from 'shared/styles.js';

const SliderContainer = styled(Box)`
  margin-top: 12px;
  width: 100%;
  height: 14px;
  border: 1px solid #abb6bc;
  border-radius: 8px;
  background-color: #f4f6f7 !important;
`;

const Slider = styled.input`
  width: 100%;
  height: 14px;
  appearance: none;
  background: transparent;
  outline: none !important;
  outline-width: 0 !important;

  &:focus,
  &:active {
    outline: none !important;
  }
  &::-webkit-slider-runnable-track {
    width: 96%;
    height: 14px;
    cursor: pointer;
  }
  &::-webkit-slider-thumb {
    outline: none;
    border: 1px solid #919891;
    height: 20px;
    width: 20px;
    border-radius: 15px;
    background: ${colors.grey2};
    cursor: pointer;
    appearance: none;
    transform: translate(-2px, -27%);
  }
  &::-moz-range-thumb {
    outline: none;
    border: 1px solid #919891;
    height: 20px;
    width: 20px;
    border-radius: 15px;
    background: ${colors.grey2};
    cursor: pointer;
    appearance: none;
    transform: translate(-2px, -15%);
  }
  &::-moz-range-progress {
    background-color: transparent;
  }
  &::-moz-range-track {
    background-color: transparent;
    height: 14px;
    cursor: pointer;
    width: 96%;
  }
  &::-ms-fill-lower {
    background-color: transparent;
  }
  &::-ms-fill-upper {
    background-color: transparent;
  }
  &::-moz-focus-outer {
    border: 0;
  }
`;

const background = ({ value = 0.0, backgroundColor = '#8ecbb5', min, max }) => {
  const range = max - min;
  const percent1 = (100 / range) * (value - min);
  const percent2 = 100 - percent1; // (100 / range) * (max - value);
  if (value >= (range - min) / 2) {
    return `linear-gradient(90deg, ${backgroundColor} ${percent1 - 2}%, #f4f6f7 ${percent2}%)`;
  }
  return `linear-gradient(270deg, #f4f6f7 ${percent2}%, ${backgroundColor} ${percent1 + 15}%)`;
};

export default ({ name, defaultValue, onChange, value, backgroundColor, min, max, label = '' }) => (
  <SliderContainer
    style={{
      background: background({ value: Number(value), backgroundColor, min, max }),
    }}
  >
    <Slider
      aria-label={label}
      name={name}
      type='range'
      min={min}
      max={max}
      defaultValue={defaultValue}
      onChange={onChange}
    />
  </SliderContainer>
);
